import { render, staticRenderFns } from "./DelMenuGroupCatalog.vue?vue&type=template&id=5dc4e070&scoped=true"
import script from "./DelMenuGroupCatalog.vue?vue&type=script&lang=js"
export * from "./DelMenuGroupCatalog.vue?vue&type=script&lang=js"
import style0 from "./DelMenuGroupCatalog.vue?vue&type=style&index=0&id=5dc4e070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc4e070",
  null
  
)

export default component.exports